import { useState } from 'react';

export const useQPagination = (initialPageSize, initialPageNum = 0) => {
  const [page, setPage] = useState(initialPageNum);
  const [pageSize, setPageSize] = useState(initialPageSize);

  // for Pagination component
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage - 1);
  };

  // for TablePagination component
  const handleChangeRowsPerPage = ({ label, value }: { label: string; value: number }) => {
    setPage(0);
    setPageSize(value);
  };

  return {
    page,
    pageSize,
    setPage,
    handleChangePage,
    handleChangeRowsPerPage,
  };
};
